import { Download } from "@/icons/Download.tsx";
import { MagnifyingGlassMinus } from "@/icons/MagnifyingGlassMinus.tsx";
import { MagnifyingGlassPlus } from "@/icons/MagnifyingGlassPlus.tsx";
import { XMark } from "@/icons/XMark.tsx";
import { useMantineTheme } from "@mantine/core";
import Lightbox from "yet-another-react-lightbox";
import {
  Captions,
  Download as LightboxDownload,
  Thumbnails,
  Zoom,
} from "yet-another-react-lightbox/plugins";

type PhotoLightBoxProps = {
  viewerOpened: boolean;
  closeViewer: () => void;
  activePhotoIndex: number | null;
  slides: {
    src: string;
    downloadUrl: string;
    description: string;
  }[];
};

export function PhotoLightBox(props: PhotoLightBoxProps) {
  const { viewerOpened, closeViewer, activePhotoIndex, slides } = props;
  const theme = useMantineTheme();
  return (
    <Lightbox
      styles={{
        root: { "--yarl__color_backdrop": "rgba(20, 20, 20, .95)" },
        captionsDescriptionContainer: {
          backgroundColor: "rgba(20, 20, 20, 1)",
        },
      }}
      render={{
        iconClose: () => <XMark size={24} className="mx-1" />,
        iconDownload: () => <Download size={20} className="mx-1" />,
        iconZoomIn: () => <MagnifyingGlassPlus size={20} className="mx-1" />,
        iconZoomOut: () => <MagnifyingGlassMinus size={20} className="mx-1" />,
      }}
      index={activePhotoIndex || 0}
      open={viewerOpened}
      close={closeViewer}
      plugins={[Captions, LightboxDownload, Zoom, Thumbnails]}
      zoom={{
        scrollToZoom: true,
      }}
      thumbnails={{
        borderRadius: 10,
        borderColor: theme.colors.violet[2],
        border: 1,
      }}
      slides={slides}
    />
  );
}
